class ScentCardSizes extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.card = this.closest('product-card');
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick(event) {
    const button = event.target.closest('.product-card__size');
    if (!button || button.disabled || button.classList.contains('is-selected')) return;

    event.preventDefault();
    this.select(button);
  }

  select(button) {
    this.querySelectorAll('.product-card__size').forEach((size) => {
      const isSelected = size === button;
      size.classList.toggle('is-selected', isSelected);
      size.setAttribute('aria-pressed', String(isSelected));
    });

    this.updateForm(button.dataset);
    this.updatePrice(button.dataset);
    this.updateImages(button.dataset);
  }

  updateForm({ variantId, productId }) {
    const input = this.card?.querySelector('.product-card__form input[name="id"]');
    if (!input) return;

    input.value = variantId;
    input.dataset.productid = productId;

    const form = input.closest('form');
    if (form) form.dataset.productid = productId;
  }

  updatePrice({ price, comparePrice }) {
    const priceElement = this.card?.querySelector('[data-scent-price]');
    const compareWrapper = this.card?.querySelector('[data-scent-compare]');
    const compareElement = compareWrapper?.querySelector('del');
    const hasCompare = Boolean(comparePrice);

    if (priceElement) {
      priceElement.textContent = price;
      priceElement.classList.toggle('price--lower-alert', hasCompare);
    }

    if (compareWrapper) compareWrapper.hidden = !hasCompare;
    if (compareElement) compareElement.textContent = comparePrice ?? '';
  }

  updateImages({ imageSrc, imageSrcset, hoverSrc, hoverSrcset }) {
    if (!imageSrc) return;

    const image = this.card?.querySelector('.ProductCard_Image:not(.ProductCard__Image--secondary)');
    const hoverImage = this.card?.querySelector('.ProductCard__Image--secondary');

    if (image) {
      image.srcset = imageSrcset ?? '';
      image.src = imageSrc;
    }

    if (!hoverImage) return;

    if (hoverSrc) {
      hoverImage.srcset = hoverSrcset ?? '';
      hoverImage.src = hoverSrc;
      hoverImage.style.display = '';
    } else {
      hoverImage.style.display = 'none';
    }
  }
}

if (!customElements.get('scent-card-sizes')) {
  customElements.define('scent-card-sizes', ScentCardSizes);
}
